import { createContext, useContext, useEffect, useState } from "react";
import { LANGS, translations } from "./translations";

const LanguageContext = createContext(null);
export const useLang = () => useContext(LanguageContext);

const BALKAN_LANGS = /^(bs|hr|sr|sl|sq|mk|me|cnr)([-_]|$)/i;

const detectLang = () => {
  try {
    const saved = localStorage.getItem("tg-lang");
    if (saved && LANGS.some((l) => l.code === saved)) return saved;
  } catch {}
  const codes = [];
  if (typeof navigator !== "undefined") {
    if (navigator.languages) codes.push(...navigator.languages);
    if (navigator.language) codes.push(navigator.language);
  }
  for (const code of codes) {
    const c = String(code).toLowerCase();
    if (BALKAN_LANGS.test(c)) return "bs";
    const base = c.split("-")[0];
    if (["fr", "de", "tr", "ar"].includes(base)) return base;
  }
  return "bs";
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(detectLang);

  useEffect(() => {
    const meta = LANGS.find((l) => l.code === lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = meta.dir;
    try {
      localStorage.setItem("tg-lang", lang);
    } catch {}
  }, [lang]);

  const t = translations[lang];

  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
}
